import { FC, useMemo, useContext } from 'react';
import useTrials from '@/hooks/data/useTrials';
import TrialsContext, { ITrialsContext } from '@/contexts/data/TrialsContext';
import { TrialGetCollection } from '@/api/dtos';
import { IHasChildren } from '@ngt/forms';


export interface ITrialsProviderProps extends IHasChildren {
    initial?: TrialGetCollection;
}

export const TrialsProvider: FC<ITrialsProviderProps> = ({ initial, children }) => {
    const trials = useTrials({ revalidateOnFocus: false, fallbackData: initial});

    return (

        <TrialsContext.Provider value={trials}>
            {children}
        </TrialsContext.Provider>
    );
}

export default TrialsProvider;
